import React from 'react';
import PropTypes from 'prop-types';
import SemProduto from '../SemProduto/SemProduto';
import SinistroApiError from '../SinistroApiError/SinistroApiError';

const Mensagens = ({ errorSinistro, exibirSemProduto }) => {
  return (
    <>
      {errorSinistro && <SinistroApiError />}
      {exibirSemProduto && <SemProduto />}
    </>
  );
};

Mensagens.propTypes = {
  errorSinistro: PropTypes.bool.isRequired,
  exibirSemProduto: PropTypes.bool.isRequired,
};

export default Mensagens;
